import * as ENDPOINTS from '@/common/constants/endpoints'
import { shouldInsertAccount } from '@/utils/account'

import { api } from '../api'

export const getPension = async ({ account, accountType }: DefaultHeader) =>
  api<Pension>(ENDPOINTS.PENSION, {
    method: 'GET',
    headers: {
      'account-type': accountType,
      ...shouldInsertAccount({ accountType, account }),
    },
  })
